import internalStateService from "../app/InternalStateService";
import { WEBUILogs } from "@tinqin/tinqin-utils/src/logging";

const LOGIN_REQUEST = "LOGIN_REQUEST";
const LOGIN_SUCCESS = "LOGIN_SUCCESS";

function login(endpoint, payload) {
    return async (dispatch, getState) => {
        let actionResult;
        await dispatch({
            type: LOGIN_REQUEST
        });
        actionResult = await dispatch(
            internalStateService.getActionByName("request.request")({
                method: "POST",
                endpoint: endpoint,
                headers: {
                    "Content-Type": "application/json"
                },
                payload: payload
            })
        );
        await dispatch({
            type: LOGIN_SUCCESS,
            payload: actionResult
        });
        let options = getState().getIn(["login"]);
        let action = options && options.getIn ? options.getIn(["actions", 0]) : null;
        if (action && action.toJS) {
            dispatch(
                internalStateService.getActionByName("siren.dispatchSirenAction")(action.toJS())
            );
        } else {
            dispatch(internalStateService.getActionByName("application.loadAppBoot")());
        }
        return actionResult;
    };
}

export function requestLogin(username = "", password = "", endpoint = "/login") {
    return dispatch => dispatch(login(endpoint, { username, password }));
}

export function resetLogin(username) {
    return internalStateService.getActionByName("request.request")({
        method: "POST",
        endpoint: "/resetPassword",
        headers: {
            "Content-Type": "application/json"
        },
        payload: {
            username
        }
    });
}

export function setCredentials(credentialType, value) {
    let payload = {
        credentialType: credentialType,
        value: value
    };
    return {
        type: "SET_CREDENTIALS",
        payload: payload
    };
}

export function setJwtToken(value) {
    let payload = {
        tokenId: value
    };
    return {
        type: "SET_JWT_TOKEN",
        payload: payload
    };
}

export function redirectToLoginScreen() {
    WEBUILogs.log("Triggered redirectToLoginScreen action.");
    return () => {
        let loginScreenPath = internalStateService.getGlobalProperties("loginScreenPath");
        if (!loginScreenPath) {
            WEBUILogs.error("Missing loginScreenPath global property.");
        } else {
            window.location = loginScreenPath;
        }
    };
}
